module.exports = __webpack_public_path__ + "img/mode3_icon.23dfcc30.png";